import React from 'react';

export function DhabaCard({ dhaba, onClick }) {
  const hasCertDhaba = dhaba.ht_certified_dhaba;
  const hasCertDining = dhaba.ht_certified_dining && !hasCertDhaba;
  const hasCertWashroom = dhaba.ht_certified_washroom && !hasCertDhaba;
  const hasBadge = hasCertDhaba || hasCertDining || hasCertWashroom;

  // Find display image: image field → first categorized photo → null
  const photos = dhaba.photos || {};
  const firstPhoto = ['exterior', 'dining', 'kitchen', 'food_storage', 'washroom', 'parking', 'menu_board']
    .map(cat => (photos[cat] || [])[0]).find(Boolean);
  const displayImage = dhaba.image || firstPhoto || null;

  return (
    <div 
      onClick={onClick}
      className="bg-white rounded-2xl shadow-sm overflow-hidden cursor-pointer mb-4 hover:shadow-md transition-shadow"
      data-testid={`dhaba-card-${dhaba.id}`}
    >
      {/* Image Section */}
      {displayImage ? (
        <div className="relative">
          <img 
            src={displayImage} 
            alt=""
            className="w-full h-36 object-cover"
          />
        </div>
      ) : (
        <div style={{ height: '80px', background: 'linear-gradient(135deg, #1A1A1A, #2D2D2D)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ fontSize: '28px', opacity: 0.3 }}>🍽️</span>
        </div>
      )}
      
      {/* Info Section */}
      <div className="p-4">
        {/* Row 1: Name + Rating */}
        <div className="flex items-start justify-between gap-2 mb-1">
          <h3 className="text-lg font-bold text-gray-900 leading-tight flex-1">{dhaba.name}</h3>
          <div className="flex items-center gap-2 flex-shrink-0">
            <span className={`px-2 py-0.5 text-xs font-bold rounded ${dhaba.isOpen ? 'bg-green-600' : 'bg-red-600'} text-white`}>
              {dhaba.isOpen ? 'OPEN' : 'CLOSED'}
            </span>
            {dhaba.rating > 0 && (
              <span className="bg-green-600 text-white px-2 py-0.5 rounded text-xs font-bold flex items-center gap-1">
                ⭐ {dhaba.rating}
              </span>
            )}
          </div>
        </div>

        {/* Row 2: HT Badges with scores */}
        {hasBadge && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
            {hasCertDhaba && (
              <>
                <img src="/images/badges/ht-certified-dhaba.png" alt="HT Certified Dhaba" style={{ height: '28px', objectFit: 'contain' }} />
                <span style={{ fontSize: '11px', color: '#92700C', fontWeight: '600' }}>
                  HT Certified Dhaba (Dining {parseFloat(dhaba.hygiene_score || 0).toFixed(1)}/5, Washroom {parseFloat(dhaba.washroom_rating || 0).toFixed(1)}/5)
                </span>
              </>
            )}
            {hasCertDining && (
              <>
                <img src="/images/badges/ht-certified-dining.png" alt="HT Certified Dining" style={{ height: '28px', objectFit: 'contain' }} />
                <span style={{ fontSize: '11px', color: '#065F46', fontWeight: '600' }}>
                  HT Certified Dining {parseFloat(dhaba.hygiene_score || 0).toFixed(1)}/5
                </span>
              </>
            )}
            {hasCertWashroom && (
              <>
                <img src="/images/badges/ht-certified-washroom.png" alt="HT Certified Washroom" style={{ height: '28px', objectFit: 'contain' }} />
                <span style={{ fontSize: '11px', color: '#1E40AF', fontWeight: '600' }}>
                  HT Certified Washroom {parseFloat(dhaba.washroom_rating || 0).toFixed(1)}/5
                </span>
              </>
            )}
          </div>
        )}
        
        {/* Row 3: Cuisine */}
        <p className="text-sm text-gray-500">{dhaba.cuisine}</p>
        
        {/* Row 4: Distance, Time, Price */}
        <div className="flex items-center gap-3 mt-2">
          <span className="text-sm font-medium flex items-center gap-1">
            <span className="text-orange-500">📍</span> {dhaba.distance}
          </span>
          {dhaba.time && (
            <span className="text-sm text-gray-500 flex items-center gap-1">
              🕐 {dhaba.time}
            </span>
          )}
          <span className="text-sm font-semibold text-orange-500">{dhaba.price}</span>
        </div>
        
        {/* Row 5: Tags */}
        {dhaba.tags?.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-3">
            {dhaba.tags.map(tag => (
              <span key={tag} className="bg-orange-50 text-orange-600 text-xs px-2 py-1 rounded">
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default DhabaCard;
